import { Box, ButtonBase, Typography, useTheme } from "@mui/material";
import React from "react";
import { useComponent } from "../../hook/component";
import { useMenu } from "../../hook/menu";
import { useSelectedNotebookPageIdMap } from "../../hook/page";
import {
  useFetchPageComponentListener,
  usePageComponent,
} from "../../hook/page/component";
import { ComponentSelectMenu } from "../menu/component";
import { CopyClipboard } from "../copyClipboard";

export const PageComponentProperty: React.FC = () => {
  const { handleOpen, setAnchorEl, anchorEl, open, onClose } = useMenu();
  const theme = useTheme();
  const { selectedNotebookPageId } = useSelectedNotebookPageIdMap();
  useFetchPageComponentListener(selectedNotebookPageId);
  const { pageComponent, setPageComponent } = usePageComponent({
    pageId: selectedNotebookPageId,
  });
  const { component } = useComponent(pageComponent?.["component-id"]);
  // console.log("PAGE_COMP_STATE", component)
  const selectVal = component?.name;

  return (
    <>
      <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <Box sx={{ width: "15rem" }}>Component ID</Box>
        <Typography>{component?.["component-id"]}</Typography>
        <CopyClipboard value={component?.["component-id"] ?? ""} />
      </Box>
      <ComponentSelectMenu
        onChange={async (comp) => {
          setPageComponent(comp);
        }}
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
      />
      <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <Box sx={{ width: "15rem" }}>Component</Box>
        <ButtonBase
          onClick={handleOpen}
          // ref={(ref) => setAnchorEl(ref)}
          sx={{
            "&:hover": {
              backgroundColor: theme.palette.action.hover,
            },
            padding: "1rem",
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "left",
          }}
        >
          <Box>
            <Typography
              sx={{
                color: selectVal ? "inherit" : theme.palette.text.disabled,
              }}
            >
              {selectVal ?? "No Value"}
            </Typography>
          </Box>
        </ButtonBase>
      </Box>
    </>
  );
};
